var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.$store.state.config.ui_type != 'bym')?_c('vip'):_c('bym_vip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }